"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _BasicInfo = _interopRequireDefault(require("./form/BasicInfo.vue"));
var _BusinessConfig = _interopRequireDefault(require("./form/BusinessConfig.vue"));
var _BusinessNotice = _interopRequireDefault(require("./form/BusinessNotice.vue"));
var _TakeoutConfig = _interopRequireDefault(require("./form/TakeoutConfig.vue"));
var _DeliveryArea = _interopRequireDefault(require("./form/DeliveryArea.vue"));
var _CommunityForm = _interopRequireDefault(require("./form/CommunityForm.vue"));
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 店铺表单组件
 * 用于新增和编辑店铺信息
 */
var _default = exports.default = {
  name: 'ShopForm',
  components: {
    BasicInfo: _BasicInfo.default,
    BusinessConfig: _BusinessConfig.default,
    TakeoutConfig: _TakeoutConfig.default,
    DeliveryArea: _DeliveryArea.default,
    BusinessNotice: _BusinessNotice.default,
    CommunityForm: _CommunityForm.default
  },
  props: {
    // 操作类型：add-新增，edit-编辑
    type: String,
    // 店铺数据，编辑时传入
    shopData: Object
  },
  data: function data() {
    return {
      activeTab: 'basic',
      // 当前激活的表单标签页
      // 表单数据
      formData: {
        storeId: null,
        imgUrl: '',
        clientImgUrl: '',
        offlineClientImgUrl: '',
        clientImgBgUrl: '',
        welfareBackgroundImgUrl: '',
        cardBackgroundImgUrl: '',
        // 基本信息
        orderExpireTime: 15,
        // 门店订单失效时间（分钟），默认15
        activityTitle: '',
        // 门店活动名称标题
        isNewStore: 0,
        // 是否为新店，1-是，0-否
        canBook: 0,
        // 是否可预定，1-可预定，0-不可预定
        storeName: '',
        // 店铺名称
        // brand: '', // 品牌
        city: '',
        // 城市
        linkName: '',
        // 联系人/电话
        storeAddress: '',
        // 地址
        orderMode: 1,
        // 点餐模式：1-快餐，2-中餐
        mapId: '',
        lat: '',
        lng: '',
        storePhone: '',
        storeMobile: '',
        fullCoverage: 0,
        suppliersId: '',
        provinceId: '',
        // 省份ID
        cityId: '',
        // 城市ID
        storeDesc: '',
        // 业务配置
        thirdStoreId: '',
        // POS/CRM编号
        isStop: 0,
        // 是否在微信小程序展示，1-展示，0-不展示
        isStopAli: 0,
        // 是否在支付宝小程序展示，1-展示，0-不展示
        openStatus: 0,
        // 营业状态
        // invoiceInfo: {
        //   dining: '', // 点餐开票
        //   recharge: '', // 充值开票
        //   voucher: '' // 购券开票
        // },
        invoiceOrder: '',
        invoiceRecharge: '',
        invoiceCoupon: '',
        invoiceType: 3,
        // 发票类型  0-普票 1-专票 2-电专 3-电普
        canRecharge: 0,
        // 启用充值
        canSurplus: 0,
        // 启用余额
        visitorMode: 0,
        // 游客模式

        // 自提外卖
        preTime: null,
        // 预定推送设置
        pushSetting: {
          selfPickup: false,
          selfPickupTime: '',
          delivery: false,
          deliveryTime: ''
        },
        bsyTimeGroup: [{
          start: null,
          end: null
        }],
        bsyPlusTime: 0,
        shippingFee: 6,
        minShippingAmount: 30,
        noShippingAmount: 68,
        shippingDto: {
          enabled: 0,
          timeRange: [],
          fee: 0
        },
        // 周期运费活动
        periodFee: {
          enabled: 0,
          dateRange: [],
          weeks: [],
          dayStartTime: '00:00',
          dayEndTime: '23:59',
          fee: 0
        },
        packMode: 0,
        bagMode: 0,
        packAmount: 0,
        bagAmount: 0,
        // 配送范围
        wsRange: 3,
        // 配送半径
        // deliveryFee: 0, // 配送费
        // freeDeliveryAmount: 0, // 免配送费金额
        markers: [],
        // 配送区域标记点
        area: 0,
        // 配送区域面积
        circle: null,
        // 圆形配送区域

        // 营业公告
        notice: '',
        // 公告内容
        notices: {},
        // businessHours: {
        //   start: '', // 营业开始时间
        //   end: '' // 营业结束时间
        // },

        // 门店地区ID
        areaId: null
      },
      regionOptions: [],
      areaOptions: [],
      // 门店地区选项
      cityOptions: [],
      supplierOptions: [],
      invoiceCompanyOptions: [],
      // 表单验证规则
      rules: {
        storeName: [{
          required: true,
          message: '请输入店面名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '长度在 2 到 20 个字符',
          trigger: 'blur'
        }]
        // brand: [{ required: true, message: '请输入品牌', trigger: 'blur' }],
        // city: [{ required: true, message: '请输入城市', trigger: 'blur' }],
        // contact: [{ required: true, message: '请输入联系人/电话', trigger: 'blur' }],
        // address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        // orderType: [{ required: true, message: '请选择点餐模式', trigger: 'change' }],
        // minOrderAmount: [{ required: true, message: '请设置起送金额', trigger: 'blur' }],
        // deliveryRadius: [{ required: true, message: '请设置配送半径', trigger: 'blur' }],
        // notice: [{ max: 200, message: '公告内容不超过200字', trigger: 'blur' }],
        // supplier: [{ required: true, message: '请选择供货商', trigger: 'change' }],
        // telephone: [{ required: true, message: '请输入门店座机号', trigger: 'blur' }],
        // emergencyContact: [{ required: true, message: '请输入紧急联系人', trigger: 'blur' }],
        // provinceId: [{ required: true, message: '请选择省份', trigger: 'change' }],
        // cityId: [{ required: true, message: '请选择城市', trigger: 'change' }]
      },
      dialogImageUrl: '',
      // 预览图片URL
      dialogVisible: false // 预览对话框显示状态
      // map: null,
    };
  },
  computed: {
    // cityOptions() {
    //   const province = this.regionOptions.find(p => p.id === this.formData.provinceId)
    //   let city;
    //   getRegionList({parentId:province}).then(res => {
    //     city = res.data
    //   })
    //   return city
    // }
  },
  created: function created() {
    var _this = this;
    (0, _shopList.getSupplierList)().then(function (res) {
      _this.supplierOptions = res.data;
    });
    (0, _shopList.getInvoiceCompanyList)().then(function (res) {
      _this.invoiceCompanyOptions = res.data;
    });
    (0, _shopList.getRegionList)({
      regionId: 1
    }).then(function (res) {
      _this.regionOptions = res.data;
    });
    (0, _shopList.getRegionList)({
      regionId: this.formData.provinceId
    }).then(function (res) {
      _this.cityOptions = res.data;
    });
    // 获取门店地区列表
    (0, _shopList.getAreaList)().then(function (res) {
      _this.areaOptions = res.data;
    });
  },
  methods: {
    /**
     * 取消操作
     * 触发cancel事件关闭标签页
     */
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    /**
     * 提交表单 - 图片已预上传为相对路径字符串，直接发送 JSON
     */
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          var submitData = _objectSpread({}, _this2.formData);

          // 处理 notices 对象：确保 iconUrl 是字符串相对路径
          if (submitData.notices) {
            submitData.notices = _this2.cleanNoticesData(submitData.notices);
          }

          // 处理周期运费活动数据（驼峰转后端需要的下划线格式）
          if (submitData.periodFee) {
            var pf = submitData.periodFee;
            var periodFeeData = {
              enable: pf.enabled !== undefined ? pf.enabled : 0,
              act_week: Array.isArray(pf.weeks) ? pf.weeks.join(',') : '',
              fee: pf.fee !== undefined ? pf.fee : 0,
              day_start_time: pf.dayStartTime || '00:00',
              day_end_time: pf.dayEndTime || '23:59'
            };
            if (pf.dateRange && Array.isArray(pf.dateRange) && pf.dateRange.length === 2) {
              periodFeeData.start = pf.dateRange[0];
              periodFeeData.end = pf.dateRange[1];
            }
            submitData.periodFee = periodFeeData;
          } else {
            submitData.periodFee = null;
          }
          _this2.$emit('submit', submitData);
        }
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**
     * 清理 notices 数据，确保 iconUrl 为字符串相对路径
     */
    cleanNoticesData: function cleanNoticesData(notices) {
      var cleanedNotices = {};
      var keys = ['ts', 'zt', 'wm', 'dt'];
      keys.forEach(function (key) {
        if (notices[key]) {
          var dateObj = {
            start: '',
            end: ''
          };
          if (notices[key].date && (0, _typeof2.default)(notices[key].date) === 'object') {
            dateObj = {
              start: notices[key].date.start || '',
              end: notices[key].date.end || ''
            };
          } else if (notices[key].dateRange && Array.isArray(notices[key].dateRange) && notices[key].dateRange.length === 2) {
            dateObj = {
              start: notices[key].dateRange[0] || '',
              end: notices[key].dateRange[1] || ''
            };
          }

          // iconUrl 已经是相对路径字符串，直接使用
          var iconUrlStr = '';
          if (typeof notices[key].iconUrl === 'string') {
            iconUrlStr = notices[key].iconUrl;
          }
          cleanedNotices[key] = {
            content: notices[key].content || '',
            iconUrl: iconUrlStr,
            date: dateObj,
            timeRange: notices[key].timeRange || {
              start: '',
              end: ''
            },
            title: notices[key].title || '',
            weeks: notices[key].weeks || []
          };
        }
      });
      return cleanedNotices;
    },
    handleProvinceChange: function handleProvinceChange() {
      this.formData.cityId = '';
    },
    addBusyTime: function addBusyTime() {
      this.formData.bsyTimeGroup.push({
        start: null,
        end: null
      });
    },
    removeBusyTime: function removeBusyTime(index) {
      this.formData.bsyTimeGroup.splice(index, 1);
    },
    /**
     * 处理社区表单数据更新
     * @param {Object} updatedData - 更新后的表单数据
     */
    handleCommunityFormUpdate: function handleCommunityFormUpdate(updatedData) {
      this.formData = _objectSpread(_objectSpread({}, this.formData), updatedData);
    },
    /**
     * 处理配送区域绘制数据变化
     * @param {Object} drawData - 绘制的数据，包括标记点、面积和圆形数据
     */
    handleDrawDataChange: function handleDrawDataChange(drawData) {
      console.log('=== Received drawData from child ===');
      console.log('Raw drawData:', drawData);
      console.log('drawData.markers:', drawData.markers);
      console.log('drawData.markers length:', drawData.markers ? drawData.markers.length : 0);
      console.log('drawData.area:', drawData.area);
      console.log('drawData.circle:', drawData.circle);

      // 处理标记点数据
      this.formData.markers = JSON.parse(JSON.stringify(drawData.markers));
      this.formData.area = Number(drawData.area); // 确保 area 是数字类型

      // 处理圆形数据
      if (drawData.circle) {
        this.formData.circle = {
          center: {
            lat: drawData.circle.center.lat,
            lng: drawData.circle.center.lng
          },
          radius: drawData.circle.radius
        };
        // 将圆形半径保存到ws_range字段（单位：米）
        this.formData.wsRange = Math.round(drawData.circle.radius);
      } else {
        this.formData.circle = null;
        // 如果没有圆形数据，将area值保存到ws_range（保持原有逻辑）
        if (this.formData.area) {
          // 将面积转换为近似的半径值保存
          var approximateRadius = Math.sqrt(this.formData.area * 1000000 / Math.PI);
          this.formData.wsRange = Math.round(approximateRadius);
        } else {
          this.formData.wsRange = 0;
        }
      }
      this.formData.markers = JSON.parse(JSON.stringify(drawData.markers));
      this.formData.area = Number(drawData.area);
    }
  },
  // 监听店铺数据变化，用于编辑时初始化表单
  watch: {
    shopData: {
      handler: function handler(val) {
        if (val) {
          // 确保 area 是数字类型
          if (val.area !== undefined) {
            val.area = Number(val.area);
          }
          // 确保 markers 是数组类型
          if (val.markers !== undefined && typeof val.markers === 'string') {
            try {
              val.markers = JSON.parse(val.markers);
            } catch (e) {
              val.markers = [];
            }
          }
          // 确保 circle 是对象类型
          if (val.circle !== undefined && typeof val.circle === 'string') {
            try {
              val.circle = JSON.parse(val.circle);
            } catch (e) {
              val.circle = null;
            }
          }

          // 验证并修复 circle 数据
          if (val.circle && (0, _typeof2.default)(val.circle) === 'object') {
            // 确保 center 存在且格式正确
            if (!val.circle.center || (0, _typeof2.default)(val.circle.center) !== 'object') {
              val.circle.center = {
                lat: 39.916527,
                lng: 116.397128
              }; // 默认北京天安门
            }

            // 确保 radius 是有效的数字
            if (val.circle.radius === undefined || val.circle.radius === null) {
              val.circle.radius = 1000; // 默认1公里
            } else {
              val.circle.radius = Number(val.circle.radius);
              // 验证半径范围
              if (isNaN(val.circle.radius) || val.circle.radius <= 0 || val.circle.radius > 50000) {
                val.circle.radius = 1000; // 使用默认值
              }
            }
          }

          // 处理包装袋和餐盒字段的默认值
          val.packMode = val.packMode !== undefined && val.packMode !== null ? val.packMode : 0;
          val.bagMode = val.bagMode !== undefined && val.bagMode !== null ? val.bagMode : 0;
          val.packAmount = val.packAmount !== undefined && val.packAmount !== null ? val.packAmount : 0;
          val.bagAmount = val.bagAmount !== undefined && val.bagAmount !== null ? val.bagAmount : 0;

          // 处理周期运费活动数据
          var periodFeeData = val.periodFee;

          // 如果 periodFee 是字符串（老数据格式），解析为对象
          if (periodFeeData && typeof periodFeeData === 'string') {
            try {
              periodFeeData = JSON.parse(periodFeeData);
            } catch (e) {
              console.error('解析周期运费活动数据失败:', e);
              periodFeeData = null;
            }
          }

          // 如果 periodFee 是对象，转换字段格式
          if (periodFeeData && (0, _typeof2.default)(periodFeeData) === 'object') {
            var pf = periodFeeData;
            // 创建新的转换后对象
            var transformedPeriodFee = {
              enabled: pf.enabled !== undefined ? pf.enabled : pf.enable !== undefined ? pf.enable : 0,
              dateRange: Array.isArray(pf.dateRange) ? pf.dateRange : [],
              weeks: Array.isArray(pf.weeks) ? pf.weeks : [],
              dayStartTime: pf.dayStartTime || pf.day_start_time || '00:00',
              dayEndTime: pf.dayEndTime || pf.day_end_time || '23:59',
              fee: pf.fee !== undefined ? pf.fee : 0
            };

            // 处理 act_week -> weeks
            if (pf.act_week !== undefined && typeof pf.act_week === 'string' && !Array.isArray(pf.weeks)) {
              transformedPeriodFee.weeks = pf.act_week.split(',').map(Number).filter(function (n) {
                return !isNaN(n);
              });
            }

            // 处理 start/end -> dateRange
            if (pf.start && pf.end && !Array.isArray(pf.dateRange)) {
              transformedPeriodFee.dateRange = [pf.start, pf.end];
            }

            // 使用 $set 确保 periodFee 是响应式的
            this.$set(val, 'periodFee', transformedPeriodFee);
            console.log('ShopForm - 处理后的 periodFee:', transformedPeriodFee);
          } else if (!periodFeeData) {
            // 如果没有周期运费活动数据，设置默认值
            var defaultPeriodFee = {
              enabled: 0,
              dateRange: [],
              weeks: [],
              dayStartTime: '00:00',
              dayEndTime: '23:59',
              fee: 0
            };
            this.$set(val, 'periodFee', defaultPeriodFee);
            console.log('ShopForm - 设置默认 periodFee:', defaultPeriodFee);
          }

          // 处理 notices 数据：将 date 对象转换为 dateRange 数组（用于 el-date-picker）
          if (val.notices && (0, _typeof2.default)(val.notices) === 'object') {
            var keys = ['ts', 'zt', 'wm', 'dt'];
            keys.forEach(function (key) {
              if (val.notices[key]) {
                // 如果是新的 date 对象格式，转换为 dateRange 数组
                if (val.notices[key].date && (0, _typeof2.default)(val.notices[key].date) === 'object') {
                  var _val$notices$key$date = val.notices[key].date,
                    start = _val$notices$key$date.start,
                    end = _val$notices$key$date.end;
                  val.notices[key].dateRange = start && end ? [start, end] : [];
                }
                // 如果没有 dateRange 且没有 date，设置空数组
                else if (!val.notices[key].dateRange) {
                  val.notices[key].dateRange = [];
                }
              }
            });
          }
          this.formData = _objectSpread(_objectSpread({}, this.formData), val);
          console.log('ShopForm - 最终 formData.periodFee:', this.formData.periodFee);
        }
      },
      immediate: true
    }
  }
};